import Store from '../../../Common/Store';

export default class ChangePriceIntro {
    constructor() {
        this.idx = 1;// 장비사용시간/금액변경 인트로 장면번호
    }
    open() {
        // const id =
        const html = `
<div id="ex3" class="work_time_modal  n1">

        <h2 class="modal_title">장비사용시간 / 금액 변경</h2>
        <div class="flex_column modal_content">
            <div class="finger">
                <img src="/img/sign/sign_finger.png" alt="finger">
                <div class="root">
                    <div class="scale1"></div>
                    <div class="scale2"></div>
                    <div class="scale3"></div>
                </div>
            </div>
            <div id="box_frame_common" class="box_frame1">
                <div class="_3frame">
                </div>

                <section class="frame">
                    <div class="close_header flex">
                        <div class="close_title c_w flex fz_13 fw_bold" onclick="$j.F.Baljoo.ModalChangePriceIntro.close(1)">다시 보지 않기</div>
                        <div class="close_icon flex" onclick="$j.F.Baljoo.ModalChangePriceIntro.close()"><img src="/img/sign/sign_white_x.png"
                                                                                  alt=""></div>
                    </div>
                    <div class="explain">
                        <h2 class="first fw_bolder">연습해볼까요 ?</h2>
                        <p class="first c_red fw_bolder ">주간 1시간 -> 하루 + 야간 1시간으로 변경</p>
                        <p class="first fw_bold ">(3.5톤 기준)</p>

                        <h2 class="last">금액을 누르면</h2>
                        <h2 class="last">임의로 변경할 수 있습니다.</h2>
                    </div>
                </section>
                <div class="box_frame_explain">
                    <div class=" first_title ">① 시간유형을 변경해주세요.</div>
                    <div class="second_title ">② 작업시간을 선택해주세요.</div>
                    <div class="third_title-2 ">③ 추가시간을 선택해주세요.</div>
                    <div class="fourth_title ">④ 금액을 누르면 임의로 변경할 수 있습니다.</div>


                </div>
                <div class="box_frame_button flex">
                    <div class="button_white flex" onclick="$j.F.Baljoo.ModalChangePriceIntro.step(-1)">이전</div>
                    <div class="button_white flex" onclick="$j.F.Baljoo.ModalChangePriceIntro.step(1)" id="modal_ex3_next">다음</div>
                    <div class="button_white flex" onclick="$j.F.Baljoo.ModalChangePriceIntro.close()" id="modal_ex3_close" style="display:none">
                        닫기
                    </div>
                </div>
            </div>


            <div class="wrap_title_wrap">
                <h3 class="wrap_title">시간유형</h3>
            </div>
            <div class="wrap flex">
                <div class="time_type_select flex_column">
                    <div class="flex fz_12">월대</div>
                    <div class="flex last">
                        <div class="flex fz_12 fw_medium">일(8시간)</div>
                        <div class="flex fz_12 fw_bolder">일(8시간)</div>
                    </div>
                    <div class="flex fz_12 fw_medium">반나절<span class="fz_12 fw_medium">(4시간)</span></div>
                    <div class="on flex start">
                        <div class="flex fz_12 fw_medium">시간</div>
                        <div class="flex fz_12 fw_bolder">시간</div>
                    </div>
                    <div class="flex fz_12 fw_medium">야간</div>
                    <div class="flex fz_12 fw_medium">회차</div>
                </div>
                <div class="cacluate_info flex_column">
                    <div class="index1">
                        <h3 class="cacluate_title ">상세사용시간</h3>
                        <div class="detail_time_wrap flex">
                            <div class="detail_time  flex">
                                <div class="content1"></div>
                                <div class="bracket_bottom"><img src="/img/sign/sign_bracket.png" alt="bracket"></div>
                            </div>
                            <ul class="detail_time_content">
                                <li class="flex selected">1일</li>
                                <li class="flex">2일</li>
                                <li class="flex">3일</li>
                                <li class="flex">4일</li>
                                <li class="flex">5달</li>
                                <li class="flex">6달</li>
                                <li class="flex">7달</li>
                                <li class="flex">8달</li>
                                <li class="flex">9달</li>
                                <li class="flex">10달</li>
                                <li class="flex">11달</li>
                                <li class="flex">12달</li>
                            </ul>
                            <div class="detail_time_price flex content1-2" value="600,000"></div>
                        </div>
                    </div>
                    <div>
                        <h3 class="cacluate_title">추가시간</h3>
                        <div class="add_time_wrap flex">
                            <div class="add_time  flex">
                                <div class="f1-5"></div>
                                <div class="bracket_bottom"><img src="/img/sign/sign_bracket.png" alt="bracket"></div>
                            </div>
                            <ul class="add_time_content">
                                <li class="morning_night_wrap flex">
                                    <span class="">주간</span>
                                    <span class="">야간</span>
                                </li>
                                <li class="selected flex">1시간</li>
                                <li class="flex">2시간</li>
                                <li class="flex">3시간</li>
                                <li class="flex">4시간</li>
                                <li class="flex">5시간</li>
                                <li class="flex">6시간</li>
                                <li class="flex">7시간</li>
                                <li class="flex">8시간</li>
                                <li class="flex">9시간</li>
                                <li class="flex">10시간</li>
                                <li class="flex">11시간</li>
                                <li class="flex">12시간</li>

                            </ul>
                            <div class="add_time_price flex fp1-5"></div>


                        </div>
                    </div>
                </div>
            </div>
            <div class="total flex">
                <div class="total_title c_blue fz_16 fw_bolder">총 금액</div>
                <div class="total_price c_red fz_16 fw_bolder"></div>
            </div>
        </div>

        <div class="modal_button flex">
            <a href="#" rel="modal:?">
                <button class="button_yellow">확인</button>
            </a>
        </div>


    </div>        
        `;

        G5['intro_view_cnt']++;
        // 헤더 없이 연다 — 내용이 자기 닫기(다시 보지 않기 / ✕)를 프레임 안에 그린다.
        // 상자 규격은 features/_price-intro.scss 의 .ui-modal--v-intro 가 잡는다.
        this.modal = $j.Ui.Modal.open({ mode: 'center', variant: 'intro', html });
    }

    /**
     * 인트로 애니메이션 단계를 진행시킨다.
     * @param n -1(이전), 1(다음)
     */
    step(n){
        let pos=this.idx+n;
        if( pos==0 ) pos=4;
        else if( pos==5) pos=1;

        this.idx=pos;

        // 4단계이면 "다음" -> "닫기"
        if( pos==4 ) {
            $('#modal_ex3_close').show();
            $('#modal_ex3_next').hide();
        }else{
            $('#modal_ex3_close').hide();
            $('#modal_ex3_next').show();
        }

        // n 으로 시작하는 클래스 모두 제거
        $('#ex3').removeClass(function(index, className) {
            return (className.match(/\bn\S+/g) || []).join(' ');
        });
        // n단계에 해당되는 애니메이션 보여주기
        $('#ex3').addClass('n'+pos);
        $('#box_frame_common').attr('class','box_frame'+pos);
    }

    /**
     * 인트로 닫기
     * @param t 1(더이상안보기)
     */
    close(t=0){
        if(t==1) Store.cookie.set("price_intro", t, { days: 7*24 });//24주
        this.modal?.close();
    }
}